import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'antd';

import { makeGetTaskProjectSectionIdList } from '../../../../../redux/projects/selectors';
import ConnectedSectionDropdownItemLabel from './ConnectedSectionDropdownItemLabel';
import ConnectedSectionTitle from './ConnectedSectionTitle';

const ConnectedProjectSectionsDropdown = ({ sectionId, projectId, sectionIdList, taskId }) => {
  const sectionItems = useMemo(
    () =>
      sectionIdList.map((sectionId) => ({
        key: `sectionsDropdown-${sectionId}`,
        label: <ConnectedSectionDropdownItemLabel projectId={projectId} sectionId={sectionId} taskId={taskId} />,
      })),
    [projectId, sectionIdList, taskId],
  );

  return !projectId ? null : (
    <Dropdown
      className={`flex align-center justify-between cursor-pointer`}
      trigger={['click']}
      menu={{
        items: sectionItems,
        style: {
          overflow: 'scroll',
          maxHeight: '300px',
        },
      }}
      placement="bottom"
    >
      <div className="flex align-center justify-between">
        <span
          className="text-gray-600 md:text-sm text-xs py-2.5 truncate"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <ConnectedSectionTitle projectId={projectId} sectionId={sectionId} />
        </span>
        <img
          src={'/images/icons/black-arrow-down.svg'}
          style={{
            cursor: 'pointer',
            height: '10px',
            width: '10px',
          }}
          alt="icon"
        />
      </div>
    </Dropdown>
  );
};

const makeMapStateToProps = () => {
  const getTaskProjectSectionIdList = makeGetTaskProjectSectionIdList();

  return (state, props) => ({
    sectionIdList: getTaskProjectSectionIdList(state, props),
  });
};

export default connect(makeMapStateToProps)(ConnectedProjectSectionsDropdown);
